"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AiResponseEnvelope () {
        return AiResponseEnvelope;
    },
    get AskConfidenceLevel () {
        return AskConfidenceLevel;
    },
    get AskConversationDetail () {
        return AskConversationDetail;
    },
    get AskConversationMessage () {
        return AskConversationMessage;
    },
    get AskConversationSuggestions () {
        return AskConversationSuggestions;
    },
    get AskConversationSummary () {
        return AskConversationSummary;
    },
    get AskSSEChunkEvent () {
        return AskSSEChunkEvent;
    },
    get AskSSECompetenciesInterviewerOutput () {
        return AskSSECompetenciesInterviewerOutput;
    },
    get AskSSECompetencyEditEvent () {
        return AskSSECompetencyEditEvent;
    },
    get AskSSECompetencyLevel () {
        return AskSSECompetencyLevel;
    },
    get AskSSECompetencySuggestion () {
        return AskSSECompetencySuggestion;
    },
    get AskSSEConversationEvent () {
        return AskSSEConversationEvent;
    },
    get AskSSEDoneEvent () {
        return AskSSEDoneEvent;
    },
    get AskSSEErrorEvent () {
        return AskSSEErrorEvent;
    },
    get AskSSEEventSchema () {
        return AskSSEEventSchema;
    },
    get AskSSEExitInterviewerEvent () {
        return AskSSEExitInterviewerEvent;
    },
    get AskSSEFormImprovement () {
        return AskSSEFormImprovement;
    },
    get AskSSEFormImprovementField () {
        return AskSSEFormImprovementField;
    },
    get AskSSEFormImprovementsEvent () {
        return AskSSEFormImprovementsEvent;
    },
    get AskSSEFormQuestionSuggestion () {
        return AskSSEFormQuestionSuggestion;
    },
    get AskSSEFormQuestionSuggestionWithId () {
        return AskSSEFormQuestionSuggestionWithId;
    },
    get AskSSEFormQuestionType () {
        return AskSSEFormQuestionType;
    },
    get AskSSEFormQuestionsEvent () {
        return AskSSEFormQuestionsEvent;
    },
    get AskSSEFormRatingScaleOption () {
        return AskSSEFormRatingScaleOption;
    },
    get AskSSEFormSuggestion () {
        return AskSSEFormSuggestion;
    },
    get AskSSEFormsEvent () {
        return AskSSEFormsEvent;
    },
    get AskSSEGoalImprovement () {
        return AskSSEGoalImprovement;
    },
    get AskSSEGoalImprovementField () {
        return AskSSEGoalImprovementField;
    },
    get AskSSEGoalImprovementsEvent () {
        return AskSSEGoalImprovementsEvent;
    },
    get AskSSEGoalSuggestion () {
        return AskSSEGoalSuggestion;
    },
    get AskSSEGoalsEvent () {
        return AskSSEGoalsEvent;
    },
    get AskSSEInterviewNotesEvent () {
        return AskSSEInterviewNotesEvent;
    },
    get AskSSEInterviewerOutputEvent () {
        return AskSSEInterviewerOutputEvent;
    },
    get AskSSEReportingAnalyticsInterviewerOutput () {
        return AskSSEReportingAnalyticsInterviewerOutput;
    },
    get AskSSEResponseImprovement () {
        return AskSSEResponseImprovement;
    },
    get AskSSEResponseImprovementQuestionType () {
        return AskSSEResponseImprovementQuestionType;
    },
    get AskSSEResponseImprovementsEvent () {
        return AskSSEResponseImprovementsEvent;
    },
    get AskSSEStatusEvent () {
        return AskSSEStatusEvent;
    },
    get AskSSEToolCallEvent () {
        return AskSSEToolCallEvent;
    },
    get AskScoreSource () {
        return AskScoreSource;
    },
    get AskSource () {
        return AskSource;
    },
    get AskStreamStage () {
        return AskStreamStage;
    },
    get ChunkProcessingResponse () {
        return ChunkProcessingResponse;
    },
    get DefaultRephraseResponseStream () {
        return DefaultRephraseResponseStream;
    },
    get EngagementCohortInsightResponseStream () {
        return EngagementCohortInsightResponseStream;
    },
    get EngagementInsightResponseStream () {
        return EngagementInsightResponseStream;
    },
    get GetAskConversationResponse () {
        return GetAskConversationResponse;
    },
    get GetAskConversationsResponse () {
        return GetAskConversationsResponse;
    },
    get GetCompanyAISettingsResponse () {
        return GetCompanyAISettingsResponse;
    },
    get HasAccessibleDocumentsResponse () {
        return HasAccessibleDocumentsResponse;
    },
    get MeetingWorkspaceInsightResponseStream () {
        return MeetingWorkspaceInsightResponseStream;
    },
    get MetaDataChunkProcessingResponse () {
        return MetaDataChunkProcessingResponse;
    },
    get MetaDataDefaultRephraseResponseStream () {
        return MetaDataDefaultRephraseResponseStream;
    },
    get MetaDataEngagementCohortInsightResponseStream () {
        return MetaDataEngagementCohortInsightResponseStream;
    },
    get MetaDataEngagementInsightResponseStream () {
        return MetaDataEngagementInsightResponseStream;
    },
    get MetaDataMeetingWorkspaceInsightResponseStream () {
        return MetaDataMeetingWorkspaceInsightResponseStream;
    },
    get MetaDataPostMeetingAnalysisResponseStream () {
        return MetaDataPostMeetingAnalysisResponseStream;
    },
    get MetaDataPreMeetingPrepResponseStream () {
        return MetaDataPreMeetingPrepResponseStream;
    },
    get MetaDataReviewCycleInsightResponseStream () {
        return MetaDataReviewCycleInsightResponseStream;
    },
    get MetaDataReviewInsightResponseStream () {
        return MetaDataReviewInsightResponseStream;
    },
    get MetaDataSurveyInsightResponseStream () {
        return MetaDataSurveyInsightResponseStream;
    },
    get MetaDataTeamMeetingWorkspaceInsightResponseStream () {
        return MetaDataTeamMeetingWorkspaceInsightResponseStream;
    },
    get PatchCompanyAISettingsResponse () {
        return PatchCompanyAISettingsResponse;
    },
    get PostCompanyAISettingsResponse () {
        return PostCompanyAISettingsResponse;
    },
    get PostEmbeddingsResponse () {
        return PostEmbeddingsResponse;
    },
    get PostMeetingAnalysisDecision () {
        return PostMeetingAnalysisDecision;
    },
    get PostMeetingAnalysisMeetingCoaching () {
        return PostMeetingAnalysisMeetingCoaching;
    },
    get PostMeetingAnalysisMissedCommitment () {
        return PostMeetingAnalysisMissedCommitment;
    },
    get PostMeetingAnalysisResponseStream () {
        return PostMeetingAnalysisResponseStream;
    },
    get PreMeetingPrepResponseStream () {
        return PreMeetingPrepResponseStream;
    },
    get ReviewCycleInsightResponseStream () {
        return ReviewCycleInsightResponseStream;
    },
    get ReviewInsightResponseStream () {
        return ReviewInsightResponseStream;
    },
    get SurveyInsightResponseStream () {
        return SurveyInsightResponseStream;
    },
    get TeamMeetingWorkspaceInsightResponseStream () {
        return TeamMeetingWorkspaceInsightResponseStream;
    },
    get buildMeetingWorkspaceInsightSchema () {
        return buildMeetingWorkspaceInsightSchema;
    },
    get buildPostMeetingAnalysisSchema () {
        return buildPostMeetingAnalysisSchema;
    },
    get buildPreMeetingPrepSchema () {
        return buildPreMeetingPrepSchema;
    },
    get buildReviewCycleInsightSchema () {
        return buildReviewCycleInsightSchema;
    },
    get buildTeamMeetingWorkspaceInsightSchema () {
        return buildTeamMeetingWorkspaceInsightSchema;
    },
    get createSurveyInsightResponseStream () {
        return createSurveyInsightResponseStream;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _harnesstypes = require("./harness-types");
const AiResponseEnvelope = _zod.z.object({
    promptHash: _zod.z.string(),
    isCached: _zod.z.boolean(),
    status: _zod.z.enum([
        "in_progress",
        "completed"
    ]),
    userId: _zod.z.string().optional(),
    createdBy: _zod.z.string().optional(),
    createdAt: _zod.z.date(),
    taskId: _zod.z.string().optional()
});
const PostEmbeddingsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const PostCompanyAISettingsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const PatchCompanyAISettingsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const GetCompanyAISettingsResponse = _models.AiSettingsSchema;
const ReviewInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    subject: _zod.z.object({
        _id: _zod.z.string().describe("The ID of the subject"),
        name: _zod.z.string().describe("The name of the subject")
    }),
    title: _zod.z.string(),
    startDate: _zod.z.string().default(new Date().toISOString()),
    completedDate: _zod.z.string().default(new Date().toISOString()),
    insight: _zod.z.object({
        summary: _zod.z.string(),
        strengths: _zod.z.array(_zod.z.string()).optional(),
        opportunities: _zod.z.array(_zod.z.string()).optional(),
        actionItems: _zod.z.array(_zod.z.string()).optional(),
        disconnects: _zod.z.array(_zod.z.string()).optional(),
        generalAssessment: _zod.z.string().default(""),
        quotes: _zod.z.array(_zod.z.string()).optional(),
        tone: _zod.z.string().optional()
    })
});
const MetaDataReviewInsightResponseStream = _zod.z.object({
    data: ReviewInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const DefaultRephraseResponseStream = _zod.z.object({
    answer: _zod.z.array(_zod.z.string()),
    detectedLanguage: _zod.z.string().optional(),
    genderedPronounsFound: _zod.z.array(_zod.z.string()),
    pronounRuleApplied: _zod.z.string()
});
const MetaDataDefaultRephraseResponseStream = _zod.z.object({
    data: DefaultRephraseResponseStream
}).extend(AiResponseEnvelope.shape);
// Base insight schema with all possible fields
const BaseSurveyInsightSchema = _zod.z.object({
    summary: _zod.z.string().describe("4-5 sentences minimum covering participation rate, key statistical findings, main themes from open-ended responses, demographic insights, and business impact."),
    sentiment: _zod.z.string().nullable().describe("string with numerical score (X/10) and detailed explanation including specific evidence from both rating data and open-ended responses, segmented by demographics where relevant.").optional(),
    keyThemesAndPatterns: _zod.z.array(_zod.z.string()).transform((arr)=>arr.slice(0, 3)).describe("The key themes and patterns of the survey.").optional(),
    outliers: _zod.z.array(_zod.z.string()).transform((arr)=>arr.slice(0, 4)).describe("The outliers of the survey.").optional(),
    crossQuestionInsights: _zod.z.array(_zod.z.string()).transform((arr)=>arr.slice(0, 3)).describe("The cross question insights of the survey.").optional(),
    recommendations: _zod.z.array(_zod.z.string()).transform((arr)=>arr.slice(0, 3)).describe("The recommendations of the survey.").optional(),
    demographicInsights: _zod.z.object({
        roleBasedAnalysis: _zod.z.string().optional(),
        jobTitlePatterns: _zod.z.string().optional(),
        responseRateByDemographics: _zod.z.string().optional(),
        demographicSpecificConcerns: _zod.z.string().optional()
    }).describe("The demographic insights of the survey.").optional()
});
const createSurveyInsightResponseStream = (settings)=>{
    const insightFields = {
        summary: BaseSurveyInsightSchema.shape.summary
    };
    // Only include fields that are enabled in settings
    if (settings.sentimentAnalysis) {
        insightFields.sentiment = BaseSurveyInsightSchema.shape.sentiment;
    }
    if (settings.keyThemesAndPatterns) {
        insightFields.keyThemesAndPatterns = BaseSurveyInsightSchema.shape.keyThemesAndPatterns;
    }
    if (settings.outliersAndNotableResponses) {
        insightFields.outliers = BaseSurveyInsightSchema.shape.outliers;
    }
    if (settings.actionableInsightsAndRecommendations) {
        insightFields.recommendations = BaseSurveyInsightSchema.shape.recommendations;
    }
    if (settings.demographicInsights) {
        insightFields.demographicInsights = BaseSurveyInsightSchema.shape.demographicInsights;
    }
    if (settings.crossQuestionInsights) {
        insightFields.crossQuestionInsights = BaseSurveyInsightSchema.shape.crossQuestionInsights;
    }
    return _zod.z.object({
        title: _zod.z.string().describe("The name of the survey"),
        startDate: _zod.z.string().nullable().describe("Start date of the analysis window in ISO 8601 format"),
        completedDate: _zod.z.string().nullable().describe("End date of the analysis window in ISO 8601 format"),
        totalResponses: _zod.z.number().describe("The total number of responses."),
        createdAt: _zod.z.string().default(new Date().toISOString()),
        createdBy: _zod.z.string().default("Automated Insights"),
        insight: _zod.z.object(insightFields)
    });
};
const SurveyInsightResponseStream = _zod.z.object({
    title: _zod.z.string().describe("The name of the survey"),
    startDate: _zod.z.string().nullable().describe("Start date of the analysis window in ISO 8601 format"),
    completedDate: _zod.z.string().nullable().describe("End date of the analysis window in ISO 8601 format"),
    totalResponses: _zod.z.number().describe("The total number of responses."),
    createdAt: _zod.z.string().default(new Date().toISOString()),
    createdBy: _zod.z.string().default("Automated Insights"),
    insight: BaseSurveyInsightSchema
});
const MetaDataSurveyInsightResponseStream = _zod.z.object({
    data: SurveyInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const EngagementInsightResponseStream = _zod.z.object({
    question: _zod.z.string().describe("The question that was asked. Do not change the question from the original."),
    cohortName: _zod.z.string().describe("The cohort or team name the question was sent to."),
    startDate: _zod.z.string().nullable().describe("Start date of the analysis window in ISO 8601 format"),
    endDate: _zod.z.string().nullable().describe("End date of the analysis window in ISO 8601 format"),
    createdAt: _zod.z.string().default(new Date().toISOString()),
    createdBy: _zod.z.string().default("Automated Insights"),
    insight: _zod.z.object({
        summary: _zod.z.string().describe("Three-sentence summary of the key findings"),
        overallSentiment: _zod.z.string().describe("Overall sentiment with percentage breakdown ex: Negative (62% negative, 25% mixed, 13% positive) Do not include No Data Available"),
        positiveExamples: _zod.z.array(_zod.z.string()).describe("Up to 3 examples of positive responses. Use array format for responses with lists, string format for regular responses. Use complete original text.").transform((arr)=>arr.slice(0, 3)),
        mixedExamples: _zod.z.array(_zod.z.string()).describe("Up to 3 examples of mixed responses. Use array format for responses with lists, string format for regular responses. Use complete original text.").transform((arr)=>arr.slice(0, 3)),
        negativeExamples: _zod.z.array(_zod.z.string()).describe("Up to 3 examples of negative responses. Use array format for responses with lists, string format for regular responses. Use complete original text.").transform((arr)=>arr.slice(0, 3)),
        themes: _zod.z.record(_zod.z.string(), _zod.z.string()).describe("A set of key themes extracted from the responses. If there are no themes return an empty object."),
        recommendations: _zod.z.array(_zod.z.string()).describe("Up to 3 actionable suggestions with a 2 sentence explanation. If there are no recommendations respond with `No Data Available`").transform((arr)=>arr.slice(0, 3))
    })
});
const MetaDataEngagementInsightResponseStream = _zod.z.object({
    data: EngagementInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const EngagementCohortInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    userId: _zod.z.string(),
    insight: _zod.z.object({
        executiveSummary: _zod.z.string(),
        keyPerformanceAreas: _zod.z.record(_zod.z.string(), _zod.z.object({
            score: _zod.z.string().describe("Score analysis with format: X.X/5 for all employees or X.X for specific cohorts"),
            potentialReasons: _zod.z.array(_zod.z.string()).min(1).max(3).describe("1-3 bulleted reasons why this score may exist"),
            recommendations: _zod.z.array(_zod.z.string()).min(1).max(3).describe("1-3 bulleted recommendations on how to increase/maintain score"),
            explanation: _zod.z.string().describe("Summary explanation paragraph")
        })),
        ENPSImprovementStrategies: _zod.z.object({
            promoterStrategies: _zod.z.array(_zod.z.string()),
            detractorStrategies: _zod.z.array(_zod.z.string()),
            passiveStrategies: _zod.z.array(_zod.z.string())
        })
    })
});
const MetaDataEngagementCohortInsightResponseStream = _zod.z.object({
    data: EngagementCohortInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const buildReviewCycleInsightSchema = (settings)=>{
    const insightFields = {
        summary: _zod.z.string()
    };
    // Only add fields for enabled sections
    if (settings.reviewToneDistribution) {
        insightFields.reviewToneDistribution = _zod.z.array(_zod.z.string()).or(_zod.z.string()).describe("Overall sentiment with percentage breakdown ex: [ Highly Positive: 43%, Moderately Positive: 29%, Neutral/Balanced: 14%, Moderately Negative: 14%, Highly Negative: 0% ]");
    }
    if (settings.highlightedReviews) {
        insightFields.highlightedReviews = _zod.z.object({
            topPerformers: _zod.z.array(_zod.z.string()).max(5).default([]),
            attentionRequired: _zod.z.array(_zod.z.string()).max(5).default([]),
            growthOpportunities: _zod.z.array(_zod.z.string()).max(5).default([])
        });
    }
    if (settings.keyStrengthsAndOpportunities) {
        insightFields.strengthsAnalysis = _zod.z.array(_zod.z.string()).default([]);
        insightFields.opportunitiesAnalysis = _zod.z.array(_zod.z.string()).default([]);
    }
    if (settings.commonThemesPositiveReviews) {
        insightFields.commonThemesForPositiveReviews = _zod.z.array(_zod.z.string()).default([]);
    }
    if (settings.commonThemesNegativeReviews) {
        insightFields.commonThemesForNegativeReviews = _zod.z.array(_zod.z.string()).default([]);
    }
    if (settings.recurringActionItems) {
        insightFields.recurringActionItems = _zod.z.array(_zod.z.string()).default([]);
    }
    if (settings.disconnectsAnalysis) {
        insightFields.disconnectsAnalysis = _zod.z.array(_zod.z.string()).default([]);
    }
    return _zod.z.object({
        createdAt: _zod.z.string().default(new Date().toISOString()),
        completed: _zod.z.boolean().default(false),
        createdBy: _zod.z.string().default("Automated Insights"),
        title: _zod.z.string(),
        startDate: _zod.z.string().default(new Date().toISOString()),
        completedDate: _zod.z.string().default(new Date().toISOString()),
        insight: _zod.z.object(insightFields).or(_zod.z.string())
    });
};
const ReviewCycleInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    title: _zod.z.string(),
    startDate: _zod.z.string().default(new Date().toISOString()),
    completedDate: _zod.z.string().default(new Date().toISOString()),
    insight: _zod.z.object({
        summary: _zod.z.string(),
        reviewToneDistribution: _zod.z.array(_zod.z.string()).or(_zod.z.string()).describe("Overall sentiment with percentage breakdown ex: [ Highly Positive: 43%, Moderately Positive: 29%, Neutral/Balanced: 14%, Moderately Negative: 14%, Highly Negative: 0% ]").optional(),
        highlightedReviews: _zod.z.object({
            topPerformers: _zod.z.array(_zod.z.string()).max(5).default([]),
            attentionRequired: _zod.z.array(_zod.z.string()).max(5).default([]),
            growthOpportunities: _zod.z.array(_zod.z.string()).max(5).default([])
        }).optional(),
        strengthsAnalysis: _zod.z.array(_zod.z.string()).default([]).optional(),
        opportunitiesAnalysis: _zod.z.array(_zod.z.string()).default([]).optional(),
        commonThemesForPositiveReviews: _zod.z.array(_zod.z.string()).default([]).optional(),
        commonThemesForNegativeReviews: _zod.z.array(_zod.z.string()).default([]).optional(),
        recurringActionItems: _zod.z.array(_zod.z.string()).default([]).optional(),
        disconnectsAnalysis: _zod.z.array(_zod.z.string()).default([]).optional()
    }).or(_zod.z.string())
});
const MetaDataReviewCycleInsightResponseStream = _zod.z.object({
    data: ReviewCycleInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const ChunkProcessingResponse = _zod.z.object({
    totalChunks: _zod.z.number(),
    completedChunks: _zod.z.number()
});
const MetaDataChunkProcessingResponse = _zod.z.object({
    data: ChunkProcessingResponse
}).extend(AiResponseEnvelope.shape);
const buildMeetingWorkspaceInsightSchema = (settings)=>{
    const insightFields = {
        executiveSummary: _zod.z.string()
    };
    // Only add fields for enabled sections
    if (settings.progressAndGrowth) {
        insightFields.progressAndGrowth = _zod.z.array(_zod.z.string());
    }
    if (settings.keyAccomplishmentsAndWins) {
        insightFields.keyAccomplishmentsAndWins = _zod.z.array(_zod.z.string());
    }
    if (settings.developmentAreasAndGrowthOpportunities) {
        insightFields.developmentAreasAndGrowthOpportunities = _zod.z.array(_zod.z.string());
    }
    if (settings.notableDiscussionsAndDecisions) {
        insightFields.notableDiscussionsAndDecisions = _zod.z.array(_zod.z.string());
    }
    if (settings.actionItemsAnalysis) {
        insightFields.actionItemAnalysis = _zod.z.string();
    }
    return _zod.z.object({
        createdAt: _zod.z.string().default(new Date().toISOString()),
        completed: _zod.z.boolean().default(false),
        createdBy: _zod.z.string().default("Automated Insights"),
        workspaceId: _zod.z.string(),
        workspaceName: _zod.z.string(),
        startDate: _zod.z.string(),
        endDate: _zod.z.string(),
        insight: _zod.z.object(insightFields)
    });
};
const MeetingWorkspaceInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    workspaceId: _zod.z.string(),
    workspaceName: _zod.z.string(),
    startDate: _zod.z.string(),
    endDate: _zod.z.string(),
    insight: _zod.z.object({
        executiveSummary: _zod.z.string(),
        progressAndGrowth: _zod.z.array(_zod.z.string()).optional(),
        keyAccomplishmentsAndWins: _zod.z.array(_zod.z.string()).optional(),
        developmentAreasAndGrowthOpportunities: _zod.z.array(_zod.z.string()).optional(),
        notableDiscussionsAndDecisions: _zod.z.array(_zod.z.string()).optional(),
        actionItemAnalysis: _zod.z.string().optional()
    })
});
const MetaDataMeetingWorkspaceInsightResponseStream = _zod.z.object({
    data: MeetingWorkspaceInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const buildTeamMeetingWorkspaceInsightSchema = (settings)=>{
    const insightFields = {
        executiveSummary: _zod.z.string()
    };
    if (settings.recurringThemesAndTopics) {
        insightFields.recurringThemesAndTopics = _zod.z.array(_zod.z.string());
    }
    if (settings.keyAccomplishmentsAndWins) {
        insightFields.keyAccomplishmentsAndWins = _zod.z.array(_zod.z.string());
    }
    if (settings.recurringChallengesAndBlockers) {
        insightFields.recurringChallengesAndBlockers = _zod.z.array(_zod.z.string());
    }
    if (settings.notableDiscussionsAndDecisions) {
        insightFields.notableDiscussionsAndDecisions = _zod.z.array(_zod.z.string());
    }
    if (settings.actionItemsAnalysis) {
        insightFields.actionItemAnalysis = _zod.z.string();
    }
    return _zod.z.object({
        createdAt: _zod.z.string().default(new Date().toISOString()),
        completed: _zod.z.boolean().default(false),
        createdBy: _zod.z.string().default("Automated Insights"),
        workspaceId: _zod.z.string(),
        workspaceName: _zod.z.string(),
        startDate: _zod.z.string(),
        endDate: _zod.z.string(),
        insight: _zod.z.object(insightFields)
    });
};
const TeamMeetingWorkspaceInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    workspaceId: _zod.z.string(),
    workspaceName: _zod.z.string(),
    startDate: _zod.z.string(),
    endDate: _zod.z.string(),
    insight: _zod.z.object({
        executiveSummary: _zod.z.string(),
        recurringThemesAndTopics: _zod.z.array(_zod.z.string()).optional(),
        keyAccomplishmentsAndWins: _zod.z.array(_zod.z.string()).optional(),
        recurringChallengesAndBlockers: _zod.z.array(_zod.z.string()).optional(),
        notableDiscussionsAndDecisions: _zod.z.array(_zod.z.string()).optional(),
        actionItemAnalysis: _zod.z.string().optional()
    })
});
const MetaDataTeamMeetingWorkspaceInsightResponseStream = _zod.z.object({
    data: TeamMeetingWorkspaceInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const buildPreMeetingPrepSchema = (settings)=>{
    const fields = {
        executiveSummary: _zod.z.string(),
        lastThreeMeetingsRecap: _zod.z.array(_zod.z.string())
    };
    if (settings.suggestedAgendaItems) {
        fields.suggestedAgendaItems = _zod.z.array(_zod.z.object({
            topic: _zod.z.string(),
            reason: _zod.z.string()
        }));
    }
    if (settings.recentFeedback) {
        fields.recentFeedback = _zod.z.array(_zod.z.string());
    }
    if (settings.recentReviews) {
        fields.recentReviews = _zod.z.string();
    }
    if (settings.surveyInsights) {
        fields.surveyInsights = _zod.z.string();
    }
    return _zod.z.object({
        createdAt: _zod.z.string().default(new Date().toISOString()),
        createdBy: _zod.z.string().default("Automated Insights"),
        completed: _zod.z.boolean().default(false),
        workspaceId: _zod.z.string(),
        workspaceName: _zod.z.string(),
        meetingId: _zod.z.string(),
        meetingName: _zod.z.string(),
        meetingDate: _zod.z.string(),
        ...fields
    });
};
const PreMeetingPrepResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    createdBy: _zod.z.string().default("Automated Insights"),
    completed: _zod.z.boolean().default(false),
    workspaceId: _zod.z.string(),
    workspaceName: _zod.z.string(),
    meetingId: _zod.z.string(),
    meetingName: _zod.z.string(),
    meetingDate: _zod.z.string(),
    executiveSummary: _zod.z.string(),
    lastThreeMeetingsRecap: _zod.z.array(_zod.z.string()),
    suggestedAgendaItems: _zod.z.array(_zod.z.object({
        topic: _zod.z.string(),
        reason: _zod.z.string()
    })).optional(),
    recentFeedback: _zod.z.array(_zod.z.string()).optional(),
    recentReviews: _zod.z.string().optional(),
    surveyInsights: _zod.z.string().optional()
});
const MetaDataPreMeetingPrepResponseStream = _zod.z.object({
    data: PreMeetingPrepResponseStream
}).extend(AiResponseEnvelope.shape);
const PostMeetingAnalysisDecision = _zod.z.object({
    decision: _zod.z.string(),
    ownerRole: _zod.z.enum([
        "manager",
        "direct_report"
    ]).nullable()
});
const PostMeetingAnalysisMissedCommitment = _zod.z.object({
    description: _zod.z.string(),
    // Not consumed by the app — the frontend resolves the displayed assignee from `assigneeRole`.
    // Requested only so the model names the person before classifying the role, which improves
    // `assigneeRole` accuracy (chain-of-thought inside a forced-JSON response).
    assigneeName: _zod.z.string(),
    assigneeRole: _zod.z.enum([
        "manager",
        "direct_report"
    ]).nullable(),
    dueDate: _zod.z.string().nullable()
});
const PostMeetingAnalysisMeetingCoaching = _zod.z.object({
    topStrength: _zod.z.string(),
    primaryDevelopmentArea: _zod.z.string(),
    oneThingToTryNextMeeting: _zod.z.string()
});
/**
 * Section content schemas keyed by their output field name. Single source of truth shared by
 * both the dynamic (runtime) and static (type-inference) schemas below so the two can't drift.
 */ const postMeetingAnalysisSectionSchemas = {
    decisions: _zod.z.array(PostMeetingAnalysisDecision),
    missedCommitments: _zod.z.array(PostMeetingAnalysisMissedCommitment),
    participationAndInclusion: _zod.z.string(),
    qualityOfDiscussion: _zod.z.string(),
    timeManagement: _zod.z.string(),
    meetingCoaching: PostMeetingAnalysisMeetingCoaching
};
/**
 * Server-stamped envelope fields shared by both schemas. `createdAt` uses the lazy factory form
 * so its default is evaluated at parse time, not once when the schema object is constructed.
 */ const postMeetingAnalysisEnvelopeFields = {
    createdAt: _zod.z.string().default(()=>new Date().toISOString()),
    createdBy: _zod.z.string().default("Automated Insights"),
    completed: _zod.z.boolean().default(false)
};
const buildPostMeetingAnalysisSchema = (settings)=>{
    const sectionFields = {};
    // `decisionsMade` is the only setting whose key differs from its output field name (`decisions`).
    if (settings.decisionsMade) sectionFields.decisions = postMeetingAnalysisSectionSchemas.decisions;
    if (settings.missedCommitments) sectionFields.missedCommitments = postMeetingAnalysisSectionSchemas.missedCommitments;
    if (settings.participationAndInclusion) sectionFields.participationAndInclusion = postMeetingAnalysisSectionSchemas.participationAndInclusion;
    if (settings.qualityOfDiscussion) sectionFields.qualityOfDiscussion = postMeetingAnalysisSectionSchemas.qualityOfDiscussion;
    if (settings.timeManagement) sectionFields.timeManagement = postMeetingAnalysisSectionSchemas.timeManagement;
    if (settings.meetingCoaching) sectionFields.meetingCoaching = postMeetingAnalysisSectionSchemas.meetingCoaching;
    // The response carries only what the model generates plus these server-stamped defaults.
    // Meeting/workspace identifiers and names are known by the caller and never echoed by the LLM.
    return _zod.z.object({
        ...postMeetingAnalysisEnvelopeFields,
        // Validity gate — decided before any analysis prose (see post-meeting-analysis.hbs).
        // When analyzable is false the result is rejected server-side; declineReason is logged only.
        analyzable: _zod.z.boolean(),
        declineReason: _zod.z.string().nullable(),
        meetingOverview: _zod.z.string(),
        ...sectionFields
    });
};
const PostMeetingAnalysisResponseStream = _zod.z.object({
    ...postMeetingAnalysisEnvelopeFields,
    // Validity-gate fields: present on the wire/cache (the runtime schema always emits them) but not
    // consumed by the frontend. analyzable is always true here — analyzable:false is rejected
    // server-side before caching — and declineReason is internal-logging only.
    analyzable: _zod.z.boolean().optional(),
    declineReason: _zod.z.string().nullable().optional(),
    meetingOverview: _zod.z.string(),
    decisions: postMeetingAnalysisSectionSchemas.decisions.optional(),
    missedCommitments: postMeetingAnalysisSectionSchemas.missedCommitments.optional(),
    participationAndInclusion: postMeetingAnalysisSectionSchemas.participationAndInclusion.optional(),
    qualityOfDiscussion: postMeetingAnalysisSectionSchemas.qualityOfDiscussion.optional(),
    timeManagement: postMeetingAnalysisSectionSchemas.timeManagement.optional(),
    meetingCoaching: postMeetingAnalysisSectionSchemas.meetingCoaching.optional()
});
const MetaDataPostMeetingAnalysisResponseStream = _zod.z.object({
    data: PostMeetingAnalysisResponseStream
}).extend(AiResponseEnvelope.shape);
const AskConfidenceLevel = _zod.z.enum([
    "high",
    "medium",
    "low"
]);
const AskScoreSource = _zod.z.enum([
    "vector",
    "hybrid",
    "rerank"
]);
const AskStreamStage = _zod.z.enum([
    "classifying",
    "searching",
    "reranking",
    "generating",
    "gathering_context"
]);
const AskSSEStatusEvent = _zod.z.object({
    type: _zod.z.literal("status"),
    stage: AskStreamStage,
    message: _zod.z.string().optional()
});
const AskSSEChunkEvent = _zod.z.object({
    type: _zod.z.literal("chunk"),
    text: _zod.z.string()
});
const AskSSEDoneEvent = _zod.z.object({
    type: _zod.z.literal("done"),
    sources: _zod.z.array(_zod.z.lazy(()=>AskSource)).optional(),
    confidence: AskConfidenceLevel,
    retrievalMetrics: _zod.z.object({
        totalChunksRetrieved: _zod.z.number(),
        chunksUsedInAnswer: _zod.z.number(),
        averageRelevanceScore: _zod.z.number(),
        scoreSource: AskScoreSource
    }).optional(),
    classification: _zod.z.object({
        agent: _zod.z.enum([
            "document",
            "general",
            "goal",
            "goal-coach",
            "form",
            "form-building-coach",
            "form-authoring-coach",
            "interviewer",
            "unsupported"
        ]),
        complexity: _zod.z.enum([
            "simple",
            "complex"
        ]),
        reasoning: _zod.z.string(),
        requiresMultiStep: _zod.z.boolean().optional(),
        suggestedDomain: _zod.z.string().optional()
    })
});
const AskSSEErrorEvent = _zod.z.object({
    type: _zod.z.literal("error"),
    message: _zod.z.string()
});
const AskSSEToolCallEvent = _zod.z.object({
    type: _zod.z.literal("tool-call"),
    toolName: _zod.z.string(),
    args: _zod.z.unknown()
});
const AskSSEGoalSuggestion = _zod.z.object({
    id: _zod.z.string(),
    name: _zod.z.string(),
    target: _zod.z.number(),
    units: _zod.z.string(),
    assigneeId: _zod.z.string(),
    assigneeName: _zod.z.string(),
    startDate: _zod.z.string(),
    endDate: _zod.z.string(),
    categories: _zod.z.array(_zod.z.object({
        id: _zod.z.string(),
        name: _zod.z.string()
    })),
    description: _zod.z.string(),
    transparency: _zod.z.enum([
        "public",
        "private"
    ])
});
const AskSSEGoalsEvent = _zod.z.object({
    type: _zod.z.literal("goals"),
    suggestions: _zod.z.array(AskSSEGoalSuggestion)
});
const AskSSEGoalImprovementField = _zod.z.enum([
    "name",
    "description",
    "target",
    "units",
    "startDate",
    "endDate",
    "checklist"
]);
const AskSSEGoalImprovement = _zod.z.object({
    id: _zod.z.string(),
    field: AskSSEGoalImprovementField,
    title: _zod.z.string(),
    rationale: _zod.z.string(),
    suggestedValue: _zod.z.string(),
    currentValue: _zod.z.string().optional(),
    checklistItemId: _zod.z.string().optional()
});
const AskSSEGoalImprovementsEvent = _zod.z.object({
    type: _zod.z.literal("goalImprovements"),
    suggestions: _zod.z.array(AskSSEGoalImprovement)
});
const AskSSEFormQuestionType = _zod.z.enum([
    "text",
    "multiline",
    "multiple-select",
    "date",
    "goal-creation",
    "goal-discussion",
    "rating-scale",
    "multiple-choice",
    "instructions",
    "numeric"
]);
const AskSSEFormRatingScaleOption = _zod.z.object({
    value: _zod.z.union([
        _zod.z.number(),
        _zod.z.literal("")
    ]),
    name: _zod.z.string(),
    description: _zod.z.string().optional()
});
const AskSSEFormQuestionSuggestion = _zod.z.object({
    question: _zod.z.string(),
    subtext: _zod.z.string().optional(),
    type: AskSSEFormQuestionType,
    is_required: _zod.z.boolean(),
    choices: _zod.z.array(_zod.z.string()).optional(),
    add_scaling: _zod.z.array(AskSSEFormRatingScaleOption).optional(),
    rating_scale: _zod.z.array(AskSSEFormRatingScaleOption).optional(),
    min: _zod.z.number().optional(),
    max: _zod.z.number().optional(),
    decimals: _zod.z.boolean().optional()
});
const AskSSEFormSuggestion = _zod.z.object({
    id: _zod.z.string(),
    name: _zod.z.string(),
    questions: _zod.z.array(AskSSEFormQuestionSuggestion)
});
const AskSSEFormsEvent = _zod.z.object({
    type: _zod.z.literal("forms"),
    suggestions: _zod.z.array(AskSSEFormSuggestion)
});
const AskSSEFormQuestionSuggestionWithId = AskSSEFormQuestionSuggestion.extend({
    id: _zod.z.string(),
    // The form it was suggested for (the form builder's route id) — lets a restored card
    // compare against whatever form is currently open. Absent when suggested outside the
    // form builder or by an older client.
    formId: _zod.z.string().optional()
});
const AskSSEFormQuestionsEvent = _zod.z.object({
    type: _zod.z.literal("formQuestions"),
    suggestions: _zod.z.array(AskSSEFormQuestionSuggestionWithId).min(1).max(3)
});
const AskSSEFormImprovementField = _zod.z.enum([
    "question",
    "subtext",
    "choices",
    "ratingScale"
]);
const AskSSEFormImprovement = _zod.z.object({
    id: _zod.z.string(),
    /** refId of the form-builder question this improvement targets. */ questionId: _zod.z.string(),
    field: AskSSEFormImprovementField,
    title: _zod.z.string(),
    rationale: _zod.z.string(),
    /** Human-readable replacement value; for 'question'/'subtext' this is applied verbatim. */ suggestedValue: _zod.z.string(),
    currentValue: _zod.z.string().optional(),
    /** Full replacement option list, only when field is 'choices'. */ suggestedChoices: _zod.z.array(_zod.z.string()).optional(),
    /** Full replacement rating-scale option list, only when field is 'ratingScale'. */ suggestedRatingScale: _zod.z.array(AskSSEFormRatingScaleOption).optional()
});
const AskSSEFormImprovementsEvent = _zod.z.object({
    type: _zod.z.literal("formImprovements"),
    suggestions: _zod.z.array(AskSSEFormImprovement)
});
const AskSSEResponseImprovementQuestionType = _zod.z.enum([
    "text",
    "multiline",
    "numeric",
    "multiple-choice",
    "multiple-select",
    "rating-scale"
]);
const AskSSEResponseImprovement = _zod.z.object({
    id: _zod.z.string(),
    /** _id of the review question whose answer this improvement replaces. */ questionId: _zod.z.string(),
    /** Index of that question's answer in the report's answers array, resolved server-side. */ questionIndex: _zod.z.number().int().min(0),
    /** The question's title, so the card can name its target without re-reading the form. */ questionTitle: _zod.z.string(),
    /** Drives how "Apply Change" writes the answer — a textarea, a number input, or a choice list. */ questionType: AskSSEResponseImprovementQuestionType,
    title: _zod.z.string(),
    rationale: _zod.z.string(),
    /** Human-readable rendering of the replacement, shown on the card. */ suggestedValue: _zod.z.string(),
    /** The replacement in the shape the answer field takes: text, a number, a chosen option label,
	 *  or a list (multiline lines / multi-select labels). Resolved and validated server-side against
	 *  the question's real options, so the client never has to trust a model-authored index. */ suggestedAnswer: _zod.z.union([
        _zod.z.string(),
        _zod.z.number(),
        _zod.z.array(_zod.z.string())
    ]),
    currentValue: _zod.z.string().optional()
});
const AskSSEResponseImprovementsEvent = _zod.z.object({
    type: _zod.z.literal("responseImprovements"),
    suggestions: _zod.z.array(AskSSEResponseImprovement)
});
const AskSSEInterviewNotesEvent = _zod.z.object({
    type: _zod.z.literal("interview_notes"),
    notes: _zod.z.record(_zod.z.string(), _zod.z.unknown()),
    harness: _harnesstypes.InterviewerHarnessType
});
const AskSSECompetencyLevel = _zod.z.object({
    rank: _zod.z.number().int().min(1).max(5),
    name: _zod.z.string(),
    description: _zod.z.string(),
    source: _zod.z.enum([
        "manual",
        "extracted",
        "inferred",
        "mapped"
    ]).default("manual")
});
const AskSSECompetencySuggestion = _zod.z.object({
    id: _zod.z.string(),
    name: _zod.z.string(),
    description: _zod.z.string(),
    isCompanyWide: _zod.z.boolean().default(false),
    status: _zod.z.literal("active"),
    levels: _zod.z.array(AskSSECompetencyLevel),
    ratingScale: _zod.z.null()
});
const AskSSECompetenciesInterviewerOutput = _zod.z.object({
    type: _zod.z.literal("interviewer_output"),
    harness: _zod.z.literal("competency"),
    suggestions: _zod.z.array(AskSSECompetencySuggestion)
});
const AskSSEReportingAnalyticsInterviewerOutput = _zod.z.object({
    type: _zod.z.literal("interviewer_output"),
    harness: _zod.z.literal("reporting_analytics_report"),
    reportConfig: _zod.z.record(_zod.z.string(), _zod.z.unknown())
});
const AskSSEInterviewerOutputEvent = _zod.z.discriminatedUnion("harness", [
    AskSSECompetenciesInterviewerOutput,
    AskSSEReportingAnalyticsInterviewerOutput
]);
const AskSSEExitInterviewerEvent = _zod.z.object({
    type: _zod.z.literal("exit_interviewer")
});
const AskSSECompetencyEditEvent = _zod.z.object({
    type: _zod.z.literal("competency_edit"),
    harness: _zod.z.literal("competency"),
    add: _zod.z.array(AskSSECompetencySuggestion),
    update: _zod.z.array(AskSSECompetencySuggestion.pick({
        name: true,
        description: true,
        isCompanyWide: true,
        levels: true
    }).partial().extend({
        id: _zod.z.string()
    })),
    remove: _zod.z.array(_zod.z.object({
        id: _zod.z.string()
    }))
});
const AskSSEConversationEvent = _zod.z.object({
    type: _zod.z.literal("conversation"),
    conversationId: _zod.z.string(),
    title: _zod.z.string().optional()
});
const AskSSEEventSchema = _zod.z.discriminatedUnion("type", [
    AskSSEStatusEvent,
    AskSSEChunkEvent,
    AskSSEToolCallEvent,
    AskSSEDoneEvent,
    AskSSEErrorEvent,
    AskSSEGoalsEvent,
    AskSSEGoalImprovementsEvent,
    AskSSEFormsEvent,
    AskSSEFormQuestionsEvent,
    AskSSEFormImprovementsEvent,
    AskSSEResponseImprovementsEvent,
    AskSSEInterviewNotesEvent,
    AskSSEInterviewerOutputEvent,
    AskSSEExitInterviewerEvent,
    AskSSECompetencyEditEvent,
    AskSSEConversationEvent
]);
const AskSource = _zod.z.object({
    s3FileId: _zod.z.string(),
    filename: _zod.z.string(),
    chunkCount: _zod.z.number(),
    relevanceScore: _zod.z.number()
});
const HasAccessibleDocumentsResponse = _zod.z.object({
    hasDocuments: _zod.z.boolean()
});
const AskConversationSummary = _zod.z.object({
    id: _utilsisomorphic.transformObjectId,
    title: _zod.z.string(),
    /** Truncated first user message. Shown nowhere today; it is what `search` matches besides the title. */ preview: _zod.z.string(),
    messageCount: _zod.z.number(),
    updatedAt: _utilsisomorphic.transformDate
});
const AskConversationSuggestions = _zod.z.object({
    goals: _zod.z.array(AskSSEGoalSuggestion).optional(),
    forms: _zod.z.array(AskSSEFormSuggestion).optional(),
    formQuestions: _zod.z.array(AskSSEFormQuestionSuggestionWithId).optional(),
    goalImprovements: _zod.z.array(AskSSEGoalImprovement).optional(),
    formImprovements: _zod.z.array(AskSSEFormImprovement).optional(),
    responseImprovements: _zod.z.array(AskSSEResponseImprovement).optional()
});
const AskConversationMessage = _zod.z.object({
    id: _utilsisomorphic.transformObjectId,
    role: _zod.z.enum([
        "user",
        "assistant"
    ]),
    content: _zod.z.string(),
    /**
	 * Citations as they were at answer time. A restored citation is a pointer,
	 * not a grant — opening one still goes through the document read path, which
	 * re-checks the user's current access.
	 */ sources: _zod.z.array(_zod.z.lazy(()=>AskSource)).optional(),
    /** Assistant turns only. Absent when the turn produced no cards. */ suggestions: AskConversationSuggestions.optional(),
    createdAt: _utilsisomorphic.transformDate
});
const AskConversationDetail = AskConversationSummary.extend({
    messages: _zod.z.array(AskConversationMessage)
});
const GetAskConversationsResponse = _zod.z.object({
    conversations: _zod.z.array(AskConversationSummary),
    /** Opaque; pass back as `cursor` for the next page. Absent when this is the last page. */ nextCursor: _zod.z.string().optional()
});
const GetAskConversationResponse = AskConversationDetail;
